"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sarezzo": {
    "08af645d": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "campiglio": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "51897df2": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "casnaghe": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72063916": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "casse": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c4f0812": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "codeole": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "54baf602": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "crocevia": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f08923fd": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "grina": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5facd495": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "irle": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c857013e": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "locarino": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e93c848c": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "noboli": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0e5396b5": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "pomeda": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f3923202": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-zanano": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "429b1421": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "stalle": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "728657b2": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "stella": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "28dd4264": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "termine": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "78528317": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "skipSearch": false
    }],
    "zanano": [{
      "hkey": "11c409fc",
      "slug": "sarezzo",
      "name": "Sarezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;